import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HomePage from './components/HomePage';
import CreateGame from './components/CreateGame';
import GameRoom from './components/GameRoom';
import JoinGame from './components/JoinGame';


function App() {
  return (
    <div className="App">
      
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/create" element={<CreateGame />} />
        <Route path="/join/:roomId" element={<JoinGame />} />
        <Route path="/game/:roomId" element={<GameRoom />} />
      </Routes>
    </div>
  );
}

export default App;